import React from "react";
import { useCanPerformWorkspaceAction } from "@hooks/permissions/useCanPerformWorkspaceAction";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { WorkspaceAction } from "@common/userWorkspaceRoles";
import { ReceiptSendersSection } from "./ReceiptSenders/ReceiptSendersSection";
import { EmailAliasesSection } from "./EmailAliases/EmailAliasesSection";
import { PhoneNumberSendersSection } from "./PhoneNumberSenders/PhoneNumberSendersSection";
import { useDocumentInboxSettingsLabel } from "./useCanShowBillInvoiceInbox";

export const WorkspaceDocumentInbox: React.FC = () => {
    const canManageWorkspaceSettings = useCanPerformWorkspaceAction(
        WorkspaceAction.WORKSPACE_SETTINGS_EDIT,
    );
    const { draftsTab } = useTypedFlags();
    const pageTitle = useDocumentInboxSettingsLabel();

    return (
        <section>
            <header className="settings__header">
                <h3>{pageTitle}</h3>
            </header>

            <main>
                <PhoneNumberSendersSection />
                <ReceiptSendersSection />
                {canManageWorkspaceSettings && (
                    <EmailAliasesSection kind="receipts" />
                )}
                {canManageWorkspaceSettings && draftsTab && (
                    <>
                        <EmailAliasesSection kind="bills" />
                        <EmailAliasesSection kind="invoices" />
                    </>
                )}
            </main>
        </section>
    );
};
